import { Diagnostics } from "@remhealth/ai";
import type { Zone } from "@remhealth/host";
import { fetchUnzonedConfig, fetchZonedConfig } from "./config";
import "./theme.scss";

const DiagnosticsPage = () => {
  return <Diagnostics unzonedConfigLoader={unzonedConfigLoader} zonedConfigLoader={zonedConfigLoader} />;

  async function unzonedConfigLoader() {
    return await fetchUnzonedConfig("bells-web");
  }

  async function zonedConfigLoader(zone: Zone) {
    return await fetchZonedConfig(zone, "bells-web");
  }
};

export default DiagnosticsPage;
